import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { where } from 'firebase/firestore';
import { combineLatest, map, of, Subject, switchMap } from 'rxjs';
import { ConfigService } from '../shared/config';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

@Injectable({
  providedIn: 'root'
})
export class StockingServiceService {

  hollydays$ = new Subject<any>()

  products: any[] = [];

  hollydays = {
    2034: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2034-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2034-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2034-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2034-12-25T00:00:00", "description": "Første juledag" }, { "date": "2034-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2034-04-02T00:00:00", "description": "Palmesøndag" }, { "date": "2034-04-06T00:00:00", "description": "Skjærtorsdag" }, { "date": "2034-04-07T00:00:00", "description": "Langfredag" }, { "date": "2034-04-09T00:00:00", "description": "Første påskedag" }, { "date": "2034-04-10T00:00:00", "description": "Andre påskedag" }, { "date": "2034-05-18T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2034-05-28T00:00:00", "description": "Første pinsedag" }, { "date": "2034-05-29T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 },
    2032: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2033-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2033-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2033-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2033-12-25T00:00:00", "description": "Første juledag" }, { "date": "2033-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2033-04-10T00:00:00", "description": "Palmesøndag" }, { "date": "2033-04-14T00:00:00", "description": "Skjærtorsdag" }, { "date": "2033-04-15T00:00:00", "description": "Langfredag" }, { "date": "2033-04-17T00:00:00", "description": "Første påskedag" }, { "date": "2033-04-18T00:00:00", "description": "Andre påskedag" }, { "date": "2033-05-26T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2033-06-05T00:00:00", "description": "Første pinsedag" }, { "date": "2033-06-06T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 },
    2031: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2031-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2031-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2031-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2031-12-25T00:00:00", "description": "Første juledag" }, { "date": "2031-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2031-04-06T00:00:00", "description": "Palmesøndag" }, { "date": "2031-04-10T00:00:00", "description": "Skjærtorsdag" }, { "date": "2031-04-11T00:00:00", "description": "Langfredag" }, { "date": "2031-04-13T00:00:00", "description": "Første påskedag" }, { "date": "2031-04-14T00:00:00", "description": "Andre påskedag" }, { "date": "2031-05-22T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2031-06-01T00:00:00", "description": "Første pinsedag" }, { "date": "2031-06-02T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 },
    2030: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2030-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2030-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2030-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2030-12-25T00:00:00", "description": "Første juledag" }, { "date": "2030-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2030-04-14T00:00:00", "description": "Palmesøndag" }, { "date": "2030-04-18T00:00:00", "description": "Skjærtorsdag" }, { "date": "2030-04-19T00:00:00", "description": "Langfredag" }, { "date": "2030-04-21T00:00:00", "description": "Første påskedag" }, { "date": "2030-04-22T00:00:00", "description": "Andre påskedag" }, { "date": "2030-05-30T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2030-06-09T00:00:00", "description": "Første pinsedag" }, { "date": "2030-06-10T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 },
    2029: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2029-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2029-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2029-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2029-12-25T00:00:00", "description": "Første juledag" }, { "date": "2029-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2029-03-25T00:00:00", "description": "Palmesøndag" }, { "date": "2029-03-29T00:00:00", "description": "Skjærtorsdag" }, { "date": "2029-03-30T00:00:00", "description": "Langfredag" }, { "date": "2029-04-01T00:00:00", "description": "Første påskedag" }, { "date": "2029-04-02T00:00:00", "description": "Andre påskedag" }, { "date": "2029-05-10T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2029-05-20T00:00:00", "description": "Første pinsedag" }, { "date": "2029-05-21T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 },
    2028: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2028-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2028-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2028-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2028-12-25T00:00:00", "description": "Første juledag" }, { "date": "2028-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2028-04-09T00:00:00", "description": "Palmesøndag" }, { "date": "2028-04-13T00:00:00", "description": "Skjærtorsdag" }, { "date": "2028-04-14T00:00:00", "description": "Langfredag" }, { "date": "2028-04-16T00:00:00", "description": "Første påskedag" }, { "date": "2028-04-17T00:00:00", "description": "Andre påskedag" }, { "date": "2028-05-25T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2028-06-04T00:00:00", "description": "Første pinsedag" }, { "date": "2028-06-05T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 },
    2027: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2027-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2027-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2027-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2027-12-25T00:00:00", "description": "Første juledag" }, { "date": "2027-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2027-03-21T00:00:00", "description": "Palmesøndag" }, { "date": "2027-03-25T00:00:00", "description": "Skjærtorsdag" }, { "date": "2027-03-26T00:00:00", "description": "Langfredag" }, { "date": "2027-03-28T00:00:00", "description": "Første påskedag" }, { "date": "2027-03-29T00:00:00", "description": "Andre påskedag" }, { "date": "2027-05-06T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2027-05-16T00:00:00", "description": "Første pinsedag" }, { "date": "2027-05-17T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 },
    2026: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2026-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2026-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2026-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2026-12-25T00:00:00", "description": "Første juledag" }, { "date": "2026-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2026-03-29T00:00:00", "description": "Palmesøndag" }, { "date": "2026-04-02T00:00:00", "description": "Skjærtorsdag" }, { "date": "2026-04-03T00:00:00", "description": "Langfredag" }, { "date": "2026-04-05T00:00:00", "description": "Første påskedag" }, { "date": "2026-04-06T00:00:00", "description": "Andre påskedag" }, { "date": "2026-05-14T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2026-05-24T00:00:00", "description": "Første pinsedag" }, { "date": "2026-05-25T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 },
    2025: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2025-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2025-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2025-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2025-12-25T00:00:00", "description": "Første juledag" }, { "date": "2025-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2025-04-13T00:00:00", "description": "Palmesøndag" }, { "date": "2025-04-17T00:00:00", "description": "Skjærtorsdag" }, { "date": "2025-04-18T00:00:00", "description": "Langfredag" }, { "date": "2025-04-20T00:00:00", "description": "Første påskedag" }, { "date": "2025-04-21T00:00:00", "description": "Andre påskedag" }, { "date": "2025-05-29T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2025-06-08T00:00:00", "description": "Første pinsedag" }, { "date": "2025-06-09T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 },
    2024: { "authenticated": false, "timeTaken": 0, "data": [{ "date": "2024-01-01T00:00:00", "description": "Første nyttårsdag" }, { "date": "2024-05-01T00:00:00", "description": "Offentlig høytidsdag" }, { "date": "2024-05-17T00:00:00", "description": "Grunnlovsdag" }, { "date": "2024-12-25T00:00:00", "description": "Første juledag" }, { "date": "2024-12-26T00:00:00", "description": "Andre juledag" }, { "date": "2024-03-24T00:00:00", "description": "Palmesøndag" }, { "date": "2024-03-28T00:00:00", "description": "Skjærtorsdag" }, { "date": "2024-03-29T00:00:00", "description": "Langfredag" }, { "date": "2024-03-31T00:00:00", "description": "Første påskedag" }, { "date": "2024-04-01T00:00:00", "description": "Andre påskedag" }, { "date": "2024-05-09T00:00:00", "description": "Kristi himmelfartsdag" }, { "date": "2024-05-19T00:00:00", "description": "Første pinsedag" }, { "date": "2024-05-20T00:00:00", "description": "Andre pinsedag" }], "statusCode": 200 }
  }


  constructor(
    private afs: AngularFirestore,
    private config: ConfigService
  ) {

  }

  getSystems$() {
    return this.afs.collection('system_info', ref =>
      ref.where('companyId', '==', this.config.companyId)
        .where('active', '==', true)
    )
      .snapshotChanges()
      .pipe(
        map(actions =>
          actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          })
        ),
        switchMap(systems => {
          // For each system, get its config observable
          const configs$ = systems.map(system =>
            this.getSystemConfig$(system.id).pipe(
              map(configSnapshot => ({
                ...system,
                systemConfig: configSnapshot.exists ? configSnapshot.data() : {}
              }))
            )
          );
          return combineLatest(configs$); // Wait for all configs
        })
      );
  }


  getMenu$(week, year) {
    // Menus are SAVED under a zero-padded week ("07-2026"), but callers pass
    // both shapes — the extra delivery dialog passes moment's `.week()`, which
    // is unpadded, so every week before week 10 looked unplanned there. Try the
    // padded id first and fall back, so both conventions resolve.
    const padded = String(week).padStart(2, '0');
    const raw = String(week);
    const menus = this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('menus');

    return menus.doc(`${padded}-${year}`).get().pipe(
      switchMap(doc => (doc.exists || padded === raw) ? of(doc) : menus.doc(`${raw}-${year}`).get()),
      map(doc => {
        const data = doc.data();
        const id = doc.id;
        return { id, ...data };
      })
    );
  }

  /**
   *     return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('menus', ref => ref.where('week', '>=', fromWeek).where('week', '<=', toWeek).where('year', '>=', fromYear).where('year', '<=', toYear)).get().pipe(
      map(snapshot => snapshot.docs.map(doc => {
        const data = doc.data();
        console.log({ doc, data });
        const id = doc.id;
        return { id, ...data };
      }))
    );
   */

  getMenus$(fromUnix, toUnix) {
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('menus', ref => ref.where('unixStartOfWeek', '>=', fromUnix).where('unixStartOfWeek', '<=', toUnix)).get().pipe(
      map(snapshot => snapshot.docs.map(doc => {
        const data = doc.data();
        console.log({ doc, data });
        const id = doc.id;
        return { id, ...data };
      }))
    );
  }

    getProductTypes() {
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).get().pipe(
      map(doc => {
        const data = doc.data() as any;
        return data ? data.productTypes || [] : [];
      })
    );
  }

  // Firestore doesn't guarantee map field order is preserved on read, so the
  // display order is kept explicitly in `productTypeOrder` (an array, which
  // Firestore does preserve). Any key missing from that array (newly added,
  // or the field doesn't exist yet) is appended alphabetically at the end.
  getProductTypesOrdered() {
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).get().pipe(
      map(doc => {
        const data = doc.data() as any;
        const productTypes: { [key: string]: string } = (data && data.productTypes) || {};
        const order: string[] = (data && data.productTypeOrder) || [];

        const orderedKeys = order.filter(key => productTypes.hasOwnProperty(key));
        const remainingKeys = Object.keys(productTypes)
          .filter(key => !orderedKeys.includes(key))
          .sort((a, b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()));

        return [...orderedKeys, ...remainingKeys].map(key => ({ key, category: productTypes[key] }));
      })
    );
  }

  saveProductTypes(rows: { key: string; category: string }[]) {
    const productTypes: { [key: string]: string } = {};
    const productTypeOrder: string[] = [];
    rows.forEach(row => {
      productTypes[row.key] = row.category;
      productTypeOrder.push(row.key);
    });
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).update({ productTypes, productTypeOrder });
  }


  getHollydays$() {
    setTimeout(() => {

      const combinedHollydays = Object.keys(this.hollydays).reduce((acc, year) => {
        const data = this.hollydays[year].data.map((item) => {
          return {
            ...item,
            date: moment(item.date),

          }
        })
        acc = [...acc, ...data]
        return acc
      }
        , [])
      this.hollydays$.next(combinedHollydays)
    }, 10)
    return this.hollydays$

    //this.http.get<any>(`https://webapi.no/api/v1/holidays/${year}`)
  }

  updateExtraDelivery(data, exdelId) {
    if (exdelId) {
      return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('extra-delivery').doc(exdelId).set(data, { merge: true });
    } else {
      return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('extra-delivery').add(data);
    }
  }

  getExtraDelivery$() {
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('extra-delivery').snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { id, ...data };
      }))
    );
  }

  getStockingSettings$() {
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).get()
  }

  getNextDeliveryNumber() {
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('extra-delivery', ref => ref.orderBy('deliveryNumber', 'desc').limit(1)).get().pipe(
      map(snapshot => {
        if (snapshot.empty) {
          return 1; // If no documents, start with 1
        } else {
          const doc = snapshot.docs[0];
          const data = doc.data() as any;
          return (data.deliveryNumber || 0) + 1; // Increment the last delivery number
        }
      }
      ));
  }

  saveSystem(system: any) {
    console.log(system);
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('system-config').doc(system.id).set(system, { merge: true });
  }
  
   getSystemBySystemId(id: string) {
  return this.afs.collection("stocking")
    .doc(this.config.getCompanyId())
    .collection('system-config', ref => ref.where('systemId', '==', id))
    .snapshotChanges()
    .pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { id, ...data };
      }))
    );
}

   getSystemBySystemIdFromInfo(id: string) {
    console.log("Fetching system info for systemId:", id);
  return this.afs.collection('system_info', ref => ref.where('systemId', '==', id))
    .snapshotChanges()
    .pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { id, ...data };
      }))
    );
}

  getSystemById(id: string) {
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('system-config').doc(id).snapshotChanges().pipe(
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        return { id, ...data };
      })
    );
  }

  getSystemConfig$(id) {
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('system-config').doc(id).get();
  }

  getProducts$() {
    console.log("Fetching products from Firestore");
    // Cache products and update on changes
    if (this.products.length === 0) {
      this.afs.collection("company").doc(this.config.getCompanyId()).collection('products').snapshotChanges().pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return { id, ...data };
        }))
      ).subscribe(products => {
        this.products = products;
      });
    }
    return this.afs.collection("company").doc(this.config.getCompanyId()).collection('products').snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { id, ...data };
      }))
    );

  }

  saveMenu(week, year, data) {
    return this.afs.collection("stocking").doc(this.config.getCompanyId()).collection('menus').doc(`${week}-${year}`).set(data, { merge: true });
  }

}

